import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import Swal from "sweetalert2";

@Component({
    selector: 'app-transfer-pickups',
    templateUrl: './bulk-assign.component.html',
    styleUrls: ['./bulk-assign.component.scss']
})

export class BulkAssignPickupsComponent implements OnInit {
    @Input() selectedRows: any;
    bulkAssignPickupsForm: FormGroup;
    isFormSubmitted = false;
    fieldExecutiveList: any[];

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private userManagmentService: UserManagementService,
        private pickupService: PickupService,
        private titleService: Title
    ) { 
        titleService.setTitle('Pickup');
    }

    ngOnInit() {
        this.bulkAssignPickupsForm = this._fb.group({
            ddlFieldExecutive: [null, Validators.compose([Validators.required])],
        });
        this.appCoreService.SelectedServiceCenter().subscribe(sc=>{
            this.bindFieldExecutive(sc);
        })
        // console.log('selectedRowss', this.selectedRows);
    }

    bindFieldExecutive(sc: number) {
        try {
            this.userManagmentService.GetUserByGroup('fe', sc).subscribe((res) => {
                if (res && res.success) {
                    const data = res.data;
                    this.fieldExecutiveList = data;
                }
            })
        }
        catch (err) {
            console.error(err);
        }
    }

    onSaveClick() {
        this.isFormSubmitted = true;
        if (this.bulkAssignPickupsForm.valid) {
            const reqObj = {
                fileldexecutiveid: this.bulkAssignPickupsForm.get('ddlFieldExecutive')?.value,
                data: this.selectedRows.map((item: any) => { return { id: item.id } })
            }
            // console.log(reqObj);
            
            this.ngxLoaderService.start();
            this.pickupService.AssignPickups(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.activeModal.dismiss('Record Updated successfully');
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Record Updated successfully', 'Success', 'success');
                }
                if (res && !res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage(res.message, 'Warning', 'warning');
                }
            })
            this.ngxLoaderService.stop();
        }
    }

    async warningDialog(msg: any) {
        await Swal.fire({
            // title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
}